<template>
  <div>

   <h3 v-show="!isChildItem">Subgroepen van {{isShown}}</h3>
   <OnlineStructureMaster :childs="childs" :name="getSubName"  v-show="!isChildItem" :menuid="templateData.data.ID">
   </OnlineStructureMaster>

     <v-layout row>
        <v-flex sm6>
        <dx-button text="+ Behandeling / pakket" @click="addService" :name="'btnAddService_' + getSubName" />
        </v-flex>
     </v-layout>

    <dx-data-grid
      :id="'serviceList' + getSubName"
      :name="'serviceList' + getSubName"
      :data-source="getServices"
      :show-borders="true"
      :column-auto-width="true"
      :show-column-headers="true"
      :no-data-text="noData"
    >
      <dx-column
        data-field="Descr"
        caption="Omschrijving"
      />
    
      <dx-column
        data-field="KindRec"
        cell-template="cellTemplateKindRec"
        caption="Soort"
      />      

       <div
        slot="cellTemplateKindRec"
        slot-scope="data"
      >
        <span v-if="data.value === 2">PAKKET</span>
        <span v-else-if="data.value === 1">BEHANDELING</span>
        <span v-else>CATEGORIE </span>
      </div>

        <dx-column
        data-field="NumOrder"
        caption="Volgorde"
        :width="80"
      />

       <dx-column
        :width="90"
        :buttons="editButtons"
        type="buttons"
      />
     
    </dx-data-grid>

     <dx-popup
      :visible.sync="popupModify"
      :drag-enabled="false"
      :close-on-outside-click="true"
      :show-title="true"
      :width="450"
      :height="370"
      class="popup"
      title="Behandeling/pakket"
    >
    
    <v-layout row>
        <v-flex sm12>
        Behandeling / pakket
        <dx-select-box placeholder="Kies behandeling/pakket" :data-source="dataSourceServLst" ref="cmbArtLst"
           value-expr="ArticleID" 
           display-expr="Title"
           @value-changed="artSelectionChanged($event)"
           v-model="artValue"
           ></dx-select-box>
        </v-flex>
    </v-layout>

     <v-layout row>
        <v-flex sm12>
        Behandeling omschrijving
        <dx-text-box v-model="txtArtMod" placeholder="Omschrijving behandeling..."></dx-text-box>
        </v-flex>
    </v-layout>
    <v-layout row><v-flex sm12>&nbsp;</v-flex></v-layout>
    <v-layout row>
        <v-flex sm6>
        Volgorde: <dx-number-box v-model="numOrder" placeholder="0" mask="99"></dx-number-box>
        </v-flex>
    </v-layout>
    <v-layout row><v-flex sm12>&nbsp;</v-flex></v-layout>
     <v-layout row>
        <v-flex sm12>
        <dx-button text="Bewaar" @click="saveArt" />
        </v-flex>
    </v-layout>
    
     
    </dx-popup>

  </div>
</template>

<script>

import myHttpApi from "../../api/myHttpApi";
import { DxDataGrid, DxColumn, DxEditing, DxPosition } from 'devextreme-vue/data-grid';
import { DxButton, DxTextBox, DxSelectBox, DxPopup, DxNumberBox } from 'devextreme-vue';
import { confirm } from 'devextreme/ui/dialog';
//import OnlineStructureMaster from "../../views/onlinereservation/OnlineStructureMaster.vue";

export default {
  components: { DxDataGrid, DxColumn, DxPopup, DxEditing, DxPosition, 
    OnlineStructureMaster : () => import ("../../views/onlinereservation/OnlineStructureMaster.vue"), 
    DxButton,
    DxTextBox,
    DxSelectBox,
    DxPopup,
    DxNumberBox 
  },
  props: {
    templateData: {
      type: Object,
      default: ()=>{}
    },
    isChild : {type : Boolean}
  },
  data() {
 
    return {
        dataSource : [],
        dataSourceServLst : [],
        editButtons: [ 
          {hint: 'Wijzig',icon: 'edit', onClick: this.onModifyClicked},
          {hint: 'Wis',icon: 'remove', onClick: this.onDeleteClicked}
        ],
        cntRows : 0,
        popupModify : false,
        txtArt : '',
        txtArtMod : '',
        numOrder : 0,
        artValue : {},
        currentRec : {},
    };
  },
   mounted() {
    this.getRemoteData()
  },
  computed: {
     noData () {
       return ("Geen behandelingen / pakketten");
     },
     isShown () {
         return this.templateData.data.Descr;
     },
     getSubName () {
         this.cntRows = this.cntRows + 1;
         var menuCtl = "subcat_" + this.templateData.data.ID + "_" + this.cntRows;
         var res = menuCtl.replace(/-/g, "_");
         console.log (res);
         
         return  res;
     },
     getServices () {
        console.log (this.templateData.data.Childs);
         var serviceList = [];
         for (var c = 0; c < this.templateData.data.Childs.length; c++)
         {
            if ((this.templateData.data.Childs[c].KindRec == 1) || (this.templateData.data.Childs[c].KindRec == 2))
            {
               serviceList.push (this.templateData.data.Childs[c]);
            }
            
         }
         return serviceList;
     },
     childs () {

        var childList = [];
         for (var c = 0; c < this.templateData.data.Childs.length; c++)
         {
            if (this.templateData.data.Childs[c].KindRec == 0)
            {
               childList.push (this.templateData.data.Childs[c]);
            }
         }

         return childList;
     },
     isChildItem () {
       return this.isChild;
     }
  },
  methods: {
    artSelectionChanged (item){

      for (var c = 0; c < this.dataSourceServLst.length; c++)
      {
        if (this.dataSourceServLst[c].ArticleID == this.artValue)
        {
            this.txtArtMod = this.dataSourceServLst[c].Title;
            break;
        }
        
      }

      
    },
    addService () {
      this.popupModify = true;
    },
    onModifyClicked (item) {

      console.log (item.row.data);
       this.txtArtMod = item.row.data.Descr;
       this.numOrder = item.row.data.NumOrder;
       this.artValue = item.row.data.RefID;
       this.currentRec = item.row.data;

       this.popupModify = true;
    },
    onDeleteClicked (item) {
       let result = confirm("Record <strong>" + item.row.data.Descr + "</strong> verwijderen.<br><br><i>Ben je zeker?</i>", "Record verwijderen");
            result.then((dialogResult) => {
                //alert(dialogResult ? "Confirmed" : "Canceled");
                if (dialogResult == true)
                {
                   myHttpApi.post('BOSettings/DelArtOnline', item.row.data)
                    .then(response => {
                        this.$emit('refreshControl', '');
                    })
                    .catch(error => {
                      console.log(error);
                    });
                }
            });
    },
    getRemoteData() {
			myHttpApi
    
      this.dataSourceServLst = [];

      myHttpApi.post('BOSettings/GetServicesAndPackages', "")
          .then(response => {
              this.dataSourceServLst = response.data;
              //console.log (this.dataSourceServLst);
          })
          .catch(error => {
            console.log(error);
          });
    },
     getServicesRemoteData() {
			myHttpApi
    
      this.dataSourceServLst = [];

      myHttpApi.post('BOSettings/GetMenuServices', this.templateData.data)
          .then(response => {
              this.dataSourceServLst = response.data;
              //console.log (this.dataSourceServLst);
          })
          .catch(error => {
            console.log(error);
          });
    },
    saveArt () {

       //console.log (this.artValue + " xxxx");
       if (this.txtArtMod.length < 2)
        {
           alert ('Behandeling omschrijving verplicht');
           return;
        }
      
        
        this.popupModify = false;

        this.currentRec.Descr = this.txtMenuMod;
        //var thenum = this.txtOrder.match(/\d+$/)[0];

        this.currentRec.NumOrder = this.numOrder;
        this.currentRec.RefID = this.artValue;
        this.currentRec.ParentID = this.templateData.data.ID;
        this.currentRec.Descr = this.txtArtMod;
        this.currentRec.KindRec = 1;  //Service

        //console.log ("records: " + this.dataSourceServLst.length);
        for (var c= 0; c < this.dataSourceServLst.length; c++)
        {
          //console.log (this.dataSourceServLst[c]);
          if (this.dataSourceServLst[c].ArticleID == this.artValue)
          {
            console.log ("found..");
             console.log (this.dataSourceServLst[c]);
             if (this.dataSourceServLst[c].IsOnlyInPackage) this.currentRec.KindRec = 2;  //Package
             break;
          }
        }

        myHttpApi.post('BOSettings/SaveArtOnline', this.currentRec)
            .then(response => {
                this.dataSource = response.data;
                //this.getRemoteData();
                this.$emit('refreshControl', '');
            })
            .catch(error => {
              console.log(error);
            });
    },
  }
};
</script>